import { render, staticRenderFns } from "./MainSidebarButton.vue?vue&type=template&id=1b4c3fb7&scoped=true&"
import script from "./MainSidebarButton.vue?vue&type=script&lang=js&"
export * from "./MainSidebarButton.vue?vue&type=script&lang=js&"
import style0 from "./MainSidebarButton.vue?vue&type=style&index=0&id=1b4c3fb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c3fb7",
  null
  
)

export default component.exports